__turbopack_context__.v({
  "badgesWrapper": "InvestorProfileField-module-scss-module__kkLv3q__badgesWrapper",
  "keywordsLabel": "InvestorProfileField-module-scss-module__kkLv3q__keywordsLabel",
  "keywordsWrapper": "InvestorProfileField-module-scss-module__kkLv3q__keywordsWrapper",
});
